var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('Task',{attrs:{"blink":"E38000242","target":"Northamptonshire","sizeMap":"cardiovascular","colorMap":"cardiovascular","showRiver":"false","allowRiverCross":"true"}})}
var staticRenderFns = []

export { render, staticRenderFns }